export function productListSlider() {
    const smallList = $(".product-list").hasClass("product-list-small");
    let productList = $(".product-list");

    productList.each(function () {
        let $this = $(this);

        $this.find(".slider").slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            prevArrow: $this.find(".common-slider-controls .prev-arrow"),
            nextArrow: $this.find(".common-slider-controls .next-arrow"),
            responsive: [
                {
                    breakpoint: 320,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1800,
                    settings: {
                        slidesToShow: (smallList) ? 5 : 4,
                    }
                }
            ]
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/product-list-slider.js